/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import { TableCell, TableRow } from "@mui/material";
import React from "react";
import moment from "moment";
import Table from "../../../../components/common/new/Table/Table";
import tableStyle from "../../../../theme/styles/table";
import styles from "./SubscriptionTable.styles";
import Typography from "../../../../components/common/new/Typography/Typography";

const tabelCellWidth = {
  tiny: {
    maxWidth: "3.5rem",
  },
  small: {
    maxWidth: "6rem",
  },
  medium: {
    maxWidth: "10rem",
  },
};

const REPORT_TABLE_COL = [
  {
    displayName: "S.NO",
    key: "s.no",
  },
  {
    displayName: "MemberShip No",
    key: "MemberShip No",
  },
  {
    displayName: "Member Name",
    key: "Member Name",
  },
  {
    displayName: "Division",
    key: "Division",
  },
  {
    displayName: "Area",
    key: "Area",
  },
  {
    displayName: "Zone",
    key: "Zone",
  },
  {
    displayName: "Region",
    key: "Region",
  },
  {
    displayName: "Chapter",
    key: "Chapter",
  },
  {
    displayName: "District",
    key: "District",
  },
  {
    displayName: "Subscription Type",
    key: "Subscription Type",
  },
  {
    displayName: "Subscription No",
    key: "Subscription No",
  },
  {
    displayName: "Start Date",
    key: "Start date",
  },
  {
    displayName: "End Date",
    key: "End date",
  },
];

const getRows = ({ searchData, currentPage, pageSize }) =>
  searchData.map((report, index) => {
    const serialNumber = index + 1 + currentPage * pageSize;
    return (
      <TableRow style={tableStyle.tableRow}>
        <TableCell style={tabelCellWidth.medium}>
          {" "}
          <Typography style={styles.typoghrphyStyle}>
            {serialNumber}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          {" "}
          <Typography style={styles.typoghrphyStyle}>
            {report?.memberId || "NA"}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          <Typography style={styles.typoghrphyStyle}>
            {report?.fullName ?? "NA"}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {report?.divisionName ?? "NA"}
            </Typography>
          </div>
        </TableCell>
        <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {report?.orgStructure?.areaName ?? "NA"}
            </Typography>
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.orgStructure?.zoneName ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.orgStructure?.regionName ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.orgStructure?.chapterName ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.orgStructure?.districtName ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.type === "FDT" ? "SS" : report?.type ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.subscriptionNumber ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.startAt
                ? moment(report?.startAt).format("DD/MM/YYYY")
                : "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {report?.endAt
                ? moment(report?.endAt).format("DD/MM/YYYY")
                : "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
      </TableRow>
    );
  });

function ReportTable({ searchData, currentPage, pageSize }) {
  return (
    <div style={styles.container}>
      <Table
        scrollable
        columns={REPORT_TABLE_COL}
        rows={getRows({
          searchData,
          currentPage,
          pageSize,
        })}
        tableHeadCellStyle={{
          ...styles.tableHeadCells,
          textAlign: "left",
        }}
        searchData={searchData}
      />
    </div>
  );
}

export default ReportTable;
